<div class="flex h-full flex-col gap-6 p-6">
  <!-- Main Content Area -->
  <div class="main-content flex h-full gap-8">
    <!-- JSON Input Section -->
    <div class="json-section flex h-full flex-col">
      <!-- Header for JSON Input -->
      <div class="flex items-center gap-3 pb-4">
        <div class="flex h-10 w-10 items-center justify-center rounded-lg bg-sky-100">
          <dojo-icon [icon]="'code'" [size]="20" class="text-sky-600" />
        </div>
        <div>
          <h2 class="text-lg font-semibold text-gray-900">Put your JSON here</h2>
          <p class="text-sm text-gray-500">Enter your question items JSON data below</p>
        </div>
      </div>

      <!-- JSON Editor -->
      <div class="flex-1 overflow-hidden rounded-lg border border-neutral-200 shadow-sm">
        <dojo-json-editor dojoQuestionItemsJsonEditor [formCtrl]="control" />
      </div>
    </div>

    <!-- Preview Section -->
    <div class="preview-section flex h-full flex-col">
      <!-- Header for Preview -->
      <div class="flex items-center gap-3 pb-4">
        <div class="flex h-10 w-10 items-center justify-center rounded-lg bg-green-100">
          <dojo-icon [icon]="'eye'" [size]="20" class="text-green-600" />
        </div>
        <div class="flex-1">
          <div class="flex items-center gap-3">
            <h2 class="text-lg font-semibold text-gray-900">Preview JSON</h2>
            @if (validationInProgress()) {
              <div class="flex items-center gap-2">
                <mat-spinner [diameter]="16" class="secondary-spinner"></mat-spinner>
                <span class="text-sm text-gray-500">Validating...</span>
              </div>
            }
          </div>
          <p class="text-sm text-gray-500">Live preview of your JSON data</p>
        </div>
      </div>

      <!-- Preview Content -->
      <div
        class="scrollbar-gutter-stable relative flex-1 overflow-y-auto rounded-lg border border-neutral-200 bg-white p-4 shadow-sm"
      >
        @if (controlErrors(); as errors) {
          <div class="error-container space-y-3">
            @for (error of errors; track error) {
              <div class="flex items-start gap-3 rounded-lg border border-red-200 bg-red-50 p-4">
                <div class="mt-0.5 flex-shrink-0">
                  <dojo-icon [icon]="'exclamation-triangle'" [size]="18" class="text-red-500" />
                </div>
                <div>
                  <p class="text-sm font-medium text-red-800">Validation Error</p>
                  <p class="mt-1 text-sm text-red-700">{{ error }}</p>
                </div>
              </div>
            }
          </div>
        } @else if (questionItems().length === 0) {
          <div class="empty-state flex h-full flex-col items-center justify-center text-center">
            <div class="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gray-100">
              <dojo-icon [icon]="'file-lines'" [size]="32" class="text-gray-400" />
            </div>
            <h3 class="mb-2 text-lg font-medium text-gray-900">No JSON data</h3>
            <p class="max-w-sm text-sm text-gray-500">
              Enter valid JSON data in the editor on the left to see a preview here.
            </p>
          </div>
        } @else {
          <dojo-question-items-preview
            [questionItems]="questionItems()"
            [markCalculationMethod]="state.markCalculationMethod"
          />
        }
      </div>
    </div>
  </div>
</div>
